<template>
  <p class="fac-number">
    掲載施設数<span>{{ total | number_format }}</span
    >件
  </p>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true
    }
  }
}
</script>
